import { createContext } from 'react';
import { ContextValue } from './types';

export const Context = createContext<ContextValue>({ user: null, setUser: null });
